import { call, put, takeLatest } from 'redux-saga/effects'

import { fetchAccount } from './helpers/account'

import { fetchAccountSuccess, FETCH_ACCOUNT } from 'Actions/account'

export default function* accountSaga() {
  yield takeLatest(FETCH_ACCOUNT, onFetchAccount)
}

const onFetchAccount = function* () {
  try {
    const account = yield call(fetchAccount)
    yield put(fetchAccountSuccess(account))
  } catch (err) {
    console.error('Unable to fetch account', err)
  }
}
